export const codInstFinancEmisorPago = 16;
export const codPaisReceptor= "cl";
